import { deepCompare } from '../../../Core/utils';
import { validateWebsiteURL } from '../../../Common/Misc/helpers/formatting/url.helper';
import { WireSocialLinkEnum } from '../enums/wire-social-link.enum';

export class WireSocialLinkModel {
    linkType: WireSocialLinkEnum;
    url: string;
    text: string;
    error: boolean = false;

    constructor(apiModel?: WireSocialLinkModel) {
        if (apiModel) {
            this.linkType = apiModel.linkType;
            this.url = apiModel.url;
            this.text = apiModel.text;
            if (apiModel.url) {
                this.isUrlValid();
            }
        }
    }

    toApiModel(): WireSocialLinkModel {
        return {
            linkType: this.linkType,
            url: this.url,
            text: this.text,
        } as WireSocialLinkModel;
    }

    clone(): WireSocialLinkModel {
        return new WireSocialLinkModel(this.toApiModel());
    }

    equals(other: WireSocialLinkModel): boolean {
        if (!other) {
            return false;
        }

        if (this.linkType !== other.linkType) {
            return false;
        }

        if (!deepCompare(this.url, other.url, { emptyChecker: 'all' })) {
            return false;
        }

        if (!deepCompare(this.text, other.text, { emptyChecker: 'all' })) {
            return false;
        }

        return true;
    }

    isUrlValid(): boolean {
        const isValid = validateWebsiteURL(this.url);
        this.error = !isValid;
        return isValid;
    }
}
